<template>
  <div>
    <h2 
      class="customTitle"
    >역대 도전</h2>

    <div v-if="records">
      <div 
        class="recordsList" 
        v-for="record in records" 
        :key="'record-' + record.id"
      >
        <span class="recordsTitle">
          <b v-if="record.is_succeed !== null">{{record.is_succeed ? '성공' : '실패'}}</b>
          <b v-else style="color: #ffb5cc">진행중</b>
        </span>
        <div class="recordsInfoBox">
          <div class="recordsInfo">
            <p v-if="record.challenge_start"><span>시작일</span> {{record.challenge_start}}</p>
            <p v-else>시작되지 않았습니다.</p>
            <p v-if="record.is_succeed !== null">
              <span v-if="record.is_succeed === true">성공일</span>
              <span v-else-if="record.is_succeed === false">포기일</span>
              {{record.challenge_finish}}
            </p>
            <div class="line"></div>
            <p>
              <span>서포터</span>
              {{record.helper.nickname}}
            </p>
            <p>
              <span>챌린저</span>
              {{record.challenger ? record.challenger.nickname : '참여하지 않았습니다.'}}
            </p>
          </div>
          <div 
            class="recordsButton" 
            @click="changeChallenge(record)"
          >MORE</div>
        </div>
      </div>
    </div>
    <div 
      v-else
      class="contentsNone"
    >
      <p class="mb-2">
        <v-icon>mdi-alert</v-icon>
      </p>
      <div class="text-center">도전한 기록이 없습니다.</div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Records",
  data() {
    return {
      records: undefined,
    };
  },
  methods: {
    getRecords() {
      // this.$axios.get("/challenges/records").then((response) => {
      //   this.records = response.data;
      // });
      this.records = [
        {
          id: 1,
          is_succeed: true,
          challenge_start: "2023-08-01",
          challenge_finish: "2023-08-07",
          helper: {
            nickname: "user2"
          },
          challenger: {
            nickname: "user1"
          }
        }
      ];
    },
    async changeChallenge(record){
      await window.localStorage.setItem('challengeInfo', JSON.stringify(record));
      await this.$router.push('/home');
    }
  },
  mounted() {
    this.getRecords();
  },
};
</script>
<style lang="scss" scoped>
.recordsList{
  position: relative;
  padding:  8px 0 8px 52px;
  border-bottom: 1px solid #ccc;

  .recordsTitle{
    width: 52px;
    position: absolute;
    left: 0;
    font-size: 14px;
  }
  .recordsInfoBox{
    display: flex;
    flex-flow: wrap;
    justify-content: space-between;
    
    p{
      margin-bottom: 4px;
      font-size: 14px;
    }
    .line{
      margin-left: -48px;
      margin-bottom: 8px;
      border-bottom: 1px dashed #ccc;
    }
    .recordsButton{
      width: 100%;
      padding: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      background-color: #ffb5cc;
      cursor: pointer;
    }
    .recordsInfo{
      width: 100%;
      padding-left: 52px;
      position: relative;
      word-break: break-all;

      span{
        width: 52px;
        position: absolute;
        left: 0;
      }
    }
  }
}
</style>